import { createRouter, createWebHashHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useUserStore } from "@/stores/user";
import { authService } from "@/services/authService"; // asegúrate de importar esto
import { betterAuthEnabled, localBetterAuthEnabled } from '@/services/betterAuthClient';
import { authDestination } from '@/services/authDestination';
//import { getCurrentUser } from '@/services/authService' // asegúrate de importar esto

const routes = [
  ...(betterAuthEnabled ? [
    ...(localBetterAuthEnabled ? [{ path: '/local-auth', meta: { layout: 'guest' }, component: () => import('../views/LocalAuthMailboxView.vue') }] : []),
    { path: '/auth-callback', meta: { layout: 'guest' }, component: () => import('../views/AuthCallbackView.vue') },
    { path: '/onboarding', meta: { layout: 'guest', requiresAuth: true }, component: () => import('../views/AuthOnboardingView.vue') },
    { path: '/recover-password', meta: { layout: 'guest' }, component: () => import('../views/AuthRecoveryView.vue') },
  ] : []),
  {
    path: "/",
    name: "raiz",
    beforeEnter: async (to, from, next) => {
      const authStore = useAuthStore();
      const userStore = useUserStore();
      const hasPaddleTransaction = new URLSearchParams(
        window.location.search,
      ).has("_ptxn");

      try {
        if (authStore.isAuthenticated && userStore.user) {
          const home = authDestination(userStore.user);
          return next(hasPaddleTransaction ? "/plans" : home);
        }

        const user = await authService.getCurrentUser();
        userStore.setUser(user);
        authStore.login();
        const home = authDestination(user);
        return next(hasPaddleTransaction ? "/plans" : home);
      } catch (err) {
        return next("/login");
      }
    },
  },
  {
    path: "/login",
    name: "Login",
    meta: { layout: "guest" },
    component: () => import("../views/Login/LoginView.vue"),
  },
  {
    path: "/invitations/:token",
    name: "teamInvitation",
    meta: { layout: "guest" },
    component: () => import("../views/InvitationView.vue"),
  },
  {
    path: "/verify-email/:token?",
    name: "verifyEmail",
    meta: { layout: "guest" },
    component: () => import("../views/VerifyEmailView.vue"),
  },
  {
    path: "/admin",
    name: "adminDashboard",
    meta: {
      layout: "app",
      requiresAuth: true,
      permission: "platform.statistics.read",
    },
    component: () => import("../views/Admin/AdminDashboard.vue"),
  },
  {
    path: "/admin/accounts",
    name: "adminAccounts",
    meta: {
      layout: "app",
      requiresAuth: true,
      permission: "platform.accounts.read",
    },
    component: () => import("../views/Admin/AdminAccounts.vue"),
  },
  {
    path: "/admin/accounts/:teamUuid",
    name: "adminAccountDetail",
    meta: {
      layout: "app",
      requiresAuth: true,
      permission: "platform.accounts.read",
    },
    component: () => import("../views/Admin/AdminAccountDetail.vue"),
  },
  {
    path: "/admin/users",
    name: "adminUsers",
    meta: {
      layout: "app",
      requiresAuth: true,
      permission: "platform.users.read",
    },
    component: () => import("../views/Admin/AdminUsers.vue"),
  },
  {
    path: "/admin/users/:userUuid",
    name: "adminUserDetail",
    meta: {
      layout: "app",
      requiresAuth: true,
      permission: "platform.users.read",
    },
    component: () => import("../views/Admin/AdminUserDetail.vue"),
  },
  {
    path: "/admin/domains",
    name: "adminDomains",
    meta: {
      layout: "app",
      requiresAuth: true,
      permission: "platform.domains.read",
    },
    component: () => import("../views/Admin/AdminDomains.vue"),
  },
  {
    path: "/admin/audit-events",
    name: "adminAuditEvents",
    meta: { layout: "app", requiresAuth: true, permission: "platform.audit.read" },
    component: () => import("../views/Admin/AdminAuditEvents.vue"),
  },
  {
    path: "/admin/error-logs",
    name: "adminErrorLogs",
    meta: { layout: "app", requiresAuth: true, permission: "platform.audit.read" },
    component: () => import("../views/Admin/AdminErrorLogs.vue"),
  },
  {
    path: "/admin/emails",
    name: "adminEmails",
    meta: { layout: "app", requiresAuth: true, permission: "platform.emails.read" },
    component: () => import("../views/Admin/AdminEmails.vue"),
  },
  {
    path: "/admin/emails/:id",
    name: "adminEmailDetail",
    meta: { layout: "app", requiresAuth: true, permission: "platform.emails.read" },
    component: () => import("../views/Client/Emails/EmailDetail.vue"),
    props: (route) => ({ id: route.params.id, admin: true }),
  },
  {
    path: "/403",
    name: "forbidden",
    meta: { layout: "app", requiresAuth: true },
    component: () => import("../views/ForbiddenView.vue"),
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: { layout: "app", requiresAuth: true, requiresTeamContext: true },
    component: () => import("../views/Client/DashboardClient.vue"),
  },
  {
    path: "/domains",
    name: "domains",
    meta: { layout: "app", requiresAuth: true, requiresTeamContext: true },
    component: () => import("../views/Client/DomainsView.vue"),
  },
  {
    path: "/emails",
    name: "emails",
    meta: { layout: "app", requiresAuth: true, requiresTeamContext: true },
    component: () => import("../views/Client/EmailsView.vue"),
  },
  // {
  //   path: "/editor",
  //   name: "editor",
  //   meta: { layout: "app", requiresAuth: true },
  //   component: () => import("../views/Client/Emails/EmailEditor.vue"),
  // },
  {
    path: "/emails/:id",
    name: "emailDetail",
    meta: { layout: "app", requiresAuth: true, requiresTeamContext: true },
    component: () => import("../views/Client/Emails/EmailDetail.vue"), // Puedes usar el mismo componente o uno diferente
    props: true,
  },
  {
    path: "/apikeys",
    name: "apikeys",
    meta: { layout: "app", requiresAuth: true, requiresTeamContext: true },
    component: () => import("../views/Client/ApiKeys"),
  },
  {
    path: "/plans",
    name: "plans",
    meta: { layout: "app", requiresAuth: true, requiresTeamContext: true },
    component: () => import("../views/Client/PlansView.vue"),
    children: [
      {
        path: ":response",
        meta: { layout: "app", requiresAuth: true },
        component: () => import("../views/Client/PlansView.vue"),
      },
    ],
  },
  {
    path: "/settings",
    name: "settings",
    meta: { layout: "app", requiresAuth: true, requiresTeamContext: true },
    component: () => import("../views/Client/SettingsView.vue"),
  },
  {
    path: "/members",
    name: "members",
    meta: { layout: "app", requiresAuth: true, requiresTeamContext: true, teamPermission: "team.members.read" },
    component: () => import("../views/Client/MembersView.vue"),
  },
  {
    path: "/notifications",
    name: "notifications",
    meta: { layout: "app", requiresAuth: true },
    component: () => import("../views/NotificationsView.vue"),
  },
  {
    path: "/settings/profile",
    name: "settingsProfile",
    meta: { layout: "app", requiresAuth: true },
    component: () => import("../views/Client/SettingsView.vue"),
  },
  {
    path: "/settings/:section",
    name: "settingsSection",
    meta: { layout: "app", requiresAuth: true, requiresTeamContext: true },
    component: () => import("../views/Client/SettingsView.vue"),
    props: true,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  console.log("🔁 Navegando a:", to.path);

  const authStore = useAuthStore();
  const userStore = useUserStore();

  const requiresAuth = to.meta.requiresAuth === true;
  const hasPaddleTransaction = new URLSearchParams(
    window.location.search,
  ).has("_ptxn");

  if (!requiresAuth) {
    console.log("🔓 Ruta pública, se permite acceso.");
    return next();
  }

  const authorizeRoute = () => {
    const requiredPermission = to.meta.permission;
    const requiredTeamPermission = to.meta.teamPermission;
    const requiresTeamContext = to.meta.requiresTeamContext === true;
    return (!requiredPermission || userStore.hasPermission(requiredPermission))
      && (!requiresTeamContext || userStore.hasActiveTeam())
      && (!requiredTeamPermission || userStore.hasTeamPermission(requiredTeamPermission));
  };

  if (authStore.isAuthenticated && userStore.user) {
    if (betterAuthEnabled && userStore.user.onboarding_required && to.path !== '/onboarding') return next('/onboarding');
    if (!authorizeRoute()) return next("/403");
    console.log("✅ Ya autenticado, se permite acceso.");
    return next(
      hasPaddleTransaction && to.path !== "/plans" ? "/plans" : undefined,
    );
  }

  try {
    console.log("🔐 Verificando sesión con /me...");
    const user = await authService.getCurrentUser();
    userStore.setUser(user);
    authStore.login();
    if (betterAuthEnabled && user.onboarding_required && to.path !== '/onboarding') return next('/onboarding');
    if (!authorizeRoute()) return next("/403");
    console.log("✅ Sesión activa, acceso permitido.");
    next(
      hasPaddleTransaction && to.path !== "/plans" ? "/plans" : undefined,
    );
  } catch (err) {
    console.warn("❌ Sesión inválida, redirigiendo a /login");
    next("/login");
  }
});

export default router;
